<div class="cf-flex-column cf-flex-1" *ngIf="inputControl">
  <label
    class="ac-form-field-label cf-flex"
    [ngClass]="{ 'ac-form-field-label-disabled': disabled, 'ac-form-field-label-readonly': readOnly }"
  >
    <span>{{ labelTextId | translate }}</span>
    <span *ngIf="required" class="required-sign"> *</span>
    <span
      *ngIf="tooltipTextId"
      class="ac-label-tooltip-container"
      [matTooltip]="tooltipTextId | translate"
      [matTooltipPosition]="tooltipPosition"
      ><mat-icon class="ac-tooltip-icon help" svgIcon="help_outline"></mat-icon
    ></span>
  </label>
  <mat-form-field [attr.data-test]="propertyKey" class="cf-flex" appearance="outline" [subscriptSizing]="subscriptSizing || 'dynamic'">
    <input
      matInput
      [type]="inputType || 'text'"
      [formControl]="inputControl"
      (focus)="focusChange.emit(true)"
      (blur)="focusChange.emit(false)"
      [placeholder]="placeholder"
    />
    <mat-error *ngIf="inputControl.errors && inputControl.errors['required']" translate> UI.Common.Validation.ValueRequired </mat-error>
    <mat-error
      *ngIf="inputControl.errors && inputControl.errors['minlength']"
      translate
      [translateParams]="{ minLength: inputControl.errors['minlength']['requiredLength'], currentLength: getCurrentLength() }"
    >
      UI.Common.Validation.ValueTooShort
    </mat-error>
    <mat-error *ngIf="inputControl.errors && inputControl.errors['pattern']" translate> UI.Validation.ValueInWrongFormat </mat-error>
    <mat-error *ngIf="inputControl.errors && inputControl.errors['email']" translate> UI.Validation.Email </mat-error>
    <mat-hint *ngIf="showLengthCounter" [ngClass]="{ 'mat-mdc-form-field-error': getCurrentLength() > getMaxLength() }" align="end"
      >{{ getCurrentLength() }}/{{ getMaxLength() }}</mat-hint
    >
  </mat-form-field>
  <ng-content></ng-content>
</div>
